export interface FetchCourseListCareersPayloadModel {
  id: number;
  name: string;
  relatedMedia: {
    render: string;
  };
}
export const FetchCourseListCareers = `
query FetchCourseListCareers {
  CourseTrail {
    all(orderBy: POSITION_ASC) {
      items {
        id
        name
        pagePost {
          postid
        }
        pagePostPart {
          postpartid
        }
        relatedMedia {
          render
        }
      }
    }
  }
}

`;
